import { LiveScreen } from '@/components/live';
import { AreaConversionsPanel } from '@/screens/parts/AreaConversionsPanel';

/**
 * Land units and what each is in hectares (owner, 2026-09-27: "are at app level and not at org
 * level"). One set for the whole application, kept by the app owner; every organisation reads it
 * and converts its plots with it. It used to sit on the Organisation page, where it looked like
 * something each organisation set for itself.
 */
export default function LandUnitsScreen() {
  return (
    <LiveScreen subtitle="What one Bigha, Katha or Acre is in hectares, by state. The same for every organisation." title="Land units">
      <AreaConversionsPanel />
    </LiveScreen>
  );
}
